import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppSettings } from './interfaces/app-settings.model';
import { environment } from '../environments/environment';

@Injectable()
export class AppSettings {

    static settings: IAppSettings;
    private httpClient: HttpClient;

    constructor(handler: HttpBackend) {
        
       console.log("AppConfig Constructor!");
       this.httpClient = new HttpClient(handler);
    }

    load() {
		const jsonFile = `assets/config/config.${environment.name}.json`;

		console.log("AppConfig is loading.....");

		return new Promise<void>((resolve, reject) => {
			this.httpClient.get(jsonFile).subscribe((response) => {
				console.log("AppConfig loading done...");
				// console.log(response);
				next: AppSettings.settings = <IAppSettings>response;
				resolve();
				// }).error((response: any) => {
				//     console.log(response);
				//     reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
				// });
			});
		});
	}
		

}